class IgridRoiTabs extends HTMLElement {
  connectedCallback() {
    this.tablist = this.querySelector('[role="tablist"]');
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

    if (this.tabs.length === 0) return;

    this.tablist.hidden = false;
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.select(index));
    });
    this.tablist.addEventListener('keydown', this.onKeydown.bind(this));

    this.select(0, { focus: false, scroll: false });

    // Lets the Theme Editor reveal a panel when its block is selected.
    document.addEventListener('shopify:block:select', (event) => {
      const index = this.panels.indexOf(event.target);
      if (index !== -1) this.select(index, { focus: false });
    });
  }

  select(index, { focus = true, scroll = true } = {}) {
    this.tabs.forEach((tab, i) => {
      const active = i === index;
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
      if (this.panels[i]) this.panels[i].hidden = !active;
    });

    const tab = this.tabs[index];
    if (focus) tab.focus();
    if (scroll && this.tablist.scrollWidth > this.tablist.clientWidth) {
      tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  }

  onKeydown(event) {
    const current = this.tabs.indexOf(document.activeElement);
    if (current === -1) return;

    const last = this.tabs.length - 1;
    let next;

    switch (event.key) {
      case 'ArrowRight':
        next = current === last ? 0 : current + 1;
        break;
      case 'ArrowLeft':
        next = current === 0 ? last : current - 1;
        break;
      case 'Home':
        next = 0;
        break;
      case 'End':
        next = last;
        break;
      default:
        return;
    }

    event.preventDefault();
    this.select(next);
  }
}

customElements.define('igrid-roi-tabs', IgridRoiTabs);
